import { useState } from "react";
import { DashboardSidebarIndex } from "./Sidebar/Index"
import "./Dashboard.scss";
import { Outlet } from "react-router-dom";
import { DashHeaderIndex } from "./Dash-header/Dash-header";

export const DashboardIndex = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <div>
                <DashHeaderIndex toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div className="dashboard-container">
                    <div className={`dashboard-sidebar ${isSidebarOpen ? 'show' : ''}`}>
                        <DashboardSidebarIndex closeSidebar={() => setIsSidebarOpen(false)} />
                    </div>
                    <div className="dashboard-content-page" onClick={() => isSidebarOpen && setIsSidebarOpen(false)}>
                        <Outlet />
                    </div>
                </div>
                {/* Backdrop for mobile */}
                {isSidebarOpen && (
                    <div
                        className="sidebar-backdrop"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}
            </div>
        </>
    );
}